export const getVisibleGlassMeasurements = (backend_name, width, height, hgp) => {
	const error = { error: 'There was an issue with the calculation.' };
	const missingParams = { error: 'Cannot calculate because a paramter is missing.' };

	const formulas = {
		'ec-csp-lifestyle-awning': {
			without_hgp: {
				width: Number(width) + 4.92,
				height: Number(height) + 4.92,
			},
			with_hgp: {
				width: Number(width) + 5.938,
				height: Number(height) + 5.938,
			},
		},
		'ec-csp-lifestyle-casement': {
			without_hgp: {
				width: Number(width) + 4.92,
				height: Number(height) + 4.92,
			},
			with_hgp: {
				width: Number(width) + 5.938,
				height: Number(height) + 5.938,
			},
		},
		'ec-csp-lifestyle-dhung': {
			width: Number(width) + 5,
			height: Number(height) * 2 + 6.3125,
		},
		'ec-csp-impervia-awning': {
			width: Number(width) + 5.4375,
			height: Number(height) + 5.4375,
		},
		'ec-csp-impervia-casement': {
			width: Number(width) + 5.4375,
			height: Number(height) + 5.4375,
		},
		'ec-csp-impervia-dhung': {
			width: Number(width) + 6.438,
			height: Number(height) * 2 + 8.376,
		},
		'ec-csp-impervia-shung': {
			width: Number(width) + 6.0625,
			height: Number(height) * 2 + 8.126,
		},
		'ec-csp-impervia-sliding-window': {
			width: (Number(width) + 4.063) * 2,
			height: Number(height) + 6.063,
		},
		'ec-csp-350-awning': {
			width: Number(width) + 7,
			height: Number(height) + 7,
		},
		'ec-csp-350-casement': {
			width: Number(width) + 7,
			height: Number(height) + 7,
		},
		'ec-csp-350-dhung': {
			width: Number(width) + 6.424,
			height: Number(height) * 2 + 7.88,
		},
		'ec-csp-350-shung': {
			width: Number(width) + 6.424,
			height: Number(height) * 2 + 7.13,
		},
		'ec-csp-350-sliding-window': {
			width: Number(width) * 2 + 7.13,
			height: Number(height) + 6.424,
		},
		'ec-csp-250-awning': {
			width: Number(width) + 6.188,
			height: Number(height) + 6.188,
		},
		'ec-csp-250-casement': {
			width: Number(width) + 6.188,
			height: Number(height) + 6.188,
		},
		'ec-csp-250-dhung': {
			width: Number(width) + 6.25,
			height: Number(height) * 2 + 8,
		},
		'ec-csp-250-shung': {
			width: Number(width) + 6.25,
			height: Number(height) * 2 + 7,
		},
		'ec-csp-250-sliding-window': {
			width: Number(width) * 2 + 6.914,
			height: Number(height) + 6.37,
		},
		'ec-csp-encompass-dhung': {
			width: Number(width) + 6.25,
			height: Number(height) * 2 + 8,
		},
		'ec-csp-encompass-shung': {
			width: Number(width) + 4.5,
			height: Number(height) * 2 + 6.375,
		},
		'ec-csp-encompass-sliding-window': {
			width: Number(width) * 2 + 7.785,
			height: Number(height) + 5.33,
		},
		'ec-csp-encompass-shung-w': {
			width: Number(width) + 5.33,
			height: Number(height) * 2 + 7.785,
		},
		'ec-csp-encompass-sliding-window-w': {
			width: Number(width) * 2 + 7.785,
			height: Number(height) + 5.33,
		},
	};

	// Guard Clauses
	if (!width || !height || !backend_name) return missingParams;
	if (width < 0 || height < 0) return error;

	if (backend_name.includes('lifestyle-awning') || backend_name.includes('lifestyle-casement')) {
		const glass = hgp ? 'with_hgp' : 'without_hgp';

		if (!formulas?.[backend_name]?.[glass]?.width) return error;
		return {
			data: {
				width: formulas[backend_name][glass].width.toFixed(2),
				height: formulas[backend_name][glass].height.toFixed(2),
			},
		};
	}

	if (!formulas?.[backend_name]?.width) return error;
	return {
		data: {
			width: formulas[backend_name].width.toFixed(2),
			height: formulas[backend_name].height.toFixed(2),
		},
	};
};
